import { createContext } from "react";

const MunicipulityCityScreen = createContext<any>(null);

export default MunicipulityCityScreen;
